import React, { useEffect, useState, useCallback } from "react";
import {
  Grid,
  Box,
  Paper,
  TableContainer,
  Table,
  TableRow,
  TableCell,
  TableBody,
  TableHead,
  Select,
  MenuItem,
  FormControl,
  Switch,
  CircularProgress,
} from "@material-ui/core";
import EditIcon from "@material-ui/icons/Edit";
import { LuArrowLeft, LuPlus } from "react-icons/lu";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import * as actions from "./actions";
import CustomAddModal from "../../../components/Common/CustomAddModal";
import AddNewVessel from "../../../components/Dashboard/AddNewVessel";
import moment from "moment";
import { isSuperAdminLogin, toastError, toastSuccess } from "../../../utils";
import _, { debounce } from "lodash";
import { getOrganizationId, isAdminLogin } from "../../../utils";
import { initialVesselState } from "../../../constants";
import CustomPagination from "../../../components/Common/CustomPagination";
import { portsByChar, updateFleetData } from "../Calculator/actions";
import CustomTabs from "../../../common/Tabs";

export default function VesselInformation(props) {
  const { setLoader = () => { }, loader = false } = props;
  const history = useHistory();
  const dispatch = useDispatch();
  const delaySearch = useCallback(
    _.debounce((filters) => getSearchedData({ ...filters }), 500),
    []
  );

  const {
    allVessels = [],
    allOrganization = [],
    allFleetByOrg = [],
  } = useSelector((state) => state.dashboard);
  const [open, setOpen] = useState(false);
  const [value, setValue] = useState(1);

  const [search, setSearch] = useState("");
  const [vessel, setVessel] = useState({ ...initialVesselState });
  const [filters, setFilters] = useState({
    vessel: "",
    offset: 1,
    limit: 25,
  });
  const [selectedOrganization, setSelectedOrganization] = useState({});
  const [fleetFilters, setFleetFilters] = useState({
    offset: 1,
    limit: 25,
  });
  const [selectedFleetId, setSelectedFleetId] = useState("");
  const [portLoading, setPortLoading] = useState(false);
  const [savePortList, setSavePortList] = useState([]);
  const [hasFetchedVessels, setHasFetchedVessels] = useState(false);
  const [hasFetchedFleets, setHasFetchedFleets] = useState(false);
  // Effect to handle fleet data merging when selectedFleetId changes
  useEffect(() => {
    if (selectedFleetId) {
      // Find the matching fleet data by _id
      const matchedFleet = allFleetByOrg.find((fleet) => fleet._id === selectedFleetId);

      if (matchedFleet) {
        // Merge fleet data into the vessel state
        setVessel((prevVessel) => ({
          ...prevVessel,
          ...matchedFleet,
        }));
      }
    }
  }, [selectedFleetId, allFleetByOrg]);
  useEffect(() => {
    getAllVessels();
  }, []);

  useEffect(() => {
    if (getOrganizationId()) {
      let selectedOrganization =
        Array.isArray(allOrganization) && allOrganization.length
          ? allOrganization.find((org) => org._id === getOrganizationId())
          : {};
      setSelectedOrganization(selectedOrganization);
    } else {
      if (allOrganization.length) setSelectedOrganization(allOrganization[0]);
    }
  }, [allOrganization]);

  useEffect(() => {
    if (selectedOrganization?._id || selectedOrganization === "allFleets") {
      getAllfleetByOrg();
    }
  }, [selectedOrganization]);

  const getInititalData = async (filters) => {
    // let requests = []
    // requests.push(getAllVessels(filters))
    // if (selectedOrganization?._id) {
    //     requests.push(getAllfleetByOrg(filters))
    // }
    setLoader(true);
    // Promise.all(requests).then(() => {
    //     setLoader(false)
    // }).catch(() => setLoader(false))
    if (value === 1) await getAllVessels(filters);
    else await getAllfleetByOrg(filters);
    setLoader(false);
  };

  const getAllVessels = async (filters) => {
    setLoader(true);
    await dispatch(actions.allVessels(filters))
      .then((res) => {
        setFilters((prev) => ({ ...prev, totalPages: res?.data?.totalPages || 0, totalItems: res?.data?.totalItems || 0 }));
        setLoader(false);
        setHasFetchedVessels(true);
      })
      .catch((err) => {
        setLoader(false);
        setHasFetchedVessels(true);
      });
  };

  const getAllfleetByOrg = async (filters) => {
    setLoader(true);
    await dispatch(
      actions.getFleetByOrg({
        ...filters,
        isValid: true,
        isPending: true,
        organizationId:
          selectedOrganization === "allFleets" ? "" : selectedOrganization?._id,
      })
    )
      .then((res) => {
        setFleetFilters((prev) => ({ ...prev, totalPages: res?.data?.totalPages || 0, totalItems: res?.data?.totalItems || 0 }));
        setLoader(false);
        setHasFetchedFleets(true);
      })
      .catch((err) => {
        toastError(err?.data?.message);
        setLoader(false);
        setHasFetchedFleets(true);
      });
  };

  const getSearchedData = (filters) => {
    setLoader(true);
    dispatch(actions.allVesselsByChar({ ...filters, skipUserId: true }))
      .then((res) => {
        setFilters((prev) => ({ ...prev, totalPages: res?.data?.totalPages || 0, totalItems: res?.data?.totalItems || 0 }));
        setLoader(false);
      })
      .catch(() => {
        setLoader(false);
      });
  };
  const onChangePort = (name, value) => {
    setVessel(prevVessel => ({
      ...prevVessel,
      port: value.name,
      selectedPort: value,
      lat: value.lat || "",
      lng: value.lng || ""
    }));
  };

  const onChangeHandler = (e) => {

    let name = "";
    let value = "";
    let type = "text";
    let checked = false;

    if (e.target) {
      ({ name = "", value = "", type = "checkbox", checked = false } = e.target);
    } else if (e._isAMomentObject) {
      name = "dateOpen";
      value = e.toISOString();
    } else {
      console.error("Unhandled event type:", e);
      return;
    }

    let newVessel = { ...vessel };
    if (type === "checkbox") {
      newVessel[name] = checked;
    } else {
      if (value && value.toString().split("")[0] === "0") return; // Prevent leading zeroes
      newVessel[name] = value;
    }
    setVessel(newVessel);
  };

  const searchVessel = (value) => {
    setSearch(value);
    // setFilters({...filters, })
    if (!!value) {
      delaySearch({ ...filters, vessel: value, skipUserId: true });
    } else {
      dispatch(actions.allVessels({ ...filters, skipUserId: true }));
    }
  };

  const onCloseModal = () => {
    setOpen(false);
    setSelectedFleetId("")
    setVessel({ ...initialVesselState });
  };

  const onSubmitConfirm = () => {
    if (!vessel.vesselName) return toastError("Vessel Name is required");
    // setLoader(true);
    const cleanedVessel = {
      ...Object.fromEntries(
        Object.entries(vessel).filter(([key]) => {
          return Object.keys(initialVesselState).includes(key)
        })
      ),

      dateOpen: vessel.dateOpen
    };

    if (value === 2) {
      actions
        .createVessel(cleanedVessel)
        .then(async (res) => {
          onCloseModal();
          setLoader(false);
          toastSuccess("Vessel created Successfully");
          setVessel({ ...initialVesselState });
          if (filters.vessel) {
            getSearchedData(filters);
          } else {
            setLoader(true);

            if (value === 2) await getAllfleetByOrg(filters);
            await getAllVessels(filters);

            setLoader(false);
          }
          setSelectedFleetId("");
        })
        .catch((err) => {
          setLoader(false);
          toastError(err?.data?.message);
          setOpen(true);
        });
      updateFleetData({ _id: selectedFleetId, superAdminApproval: "approved" })
    } else {
      actions
        .updateVesselWithFleetDetails({ ...cleanedVessel, _id: vessel._id })
        .then(async (res) => {
          onCloseModal();
          setLoader(false);
          toastSuccess("Vessel updated Successfully");
          setVessel({ ...initialVesselState });
          if (filters.vessel) {
            getSearchedData(filters);
          } else {
            setLoader(true);

            if (value === 2) await getAllfleetByOrg(filters);
            await getAllVessels(filters);

            setLoader(false);
          }
          setSelectedFleetId("");
        })
        .catch((err) => {
          setLoader(false);
          toastError(err?.data?.message);
          setOpen(true);
        });
    }
    return;
  };

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const onClickEdit = (item, id) => {
    setVessel(item);
    setOpen(true);
  };

  const handleApproveVessel = (item, isApproved) => {
    setLoader(true);
    actions.updateVesselWithFleetDetails({ _id: item._id, isApproved })
      .then((res) => {
        setLoader(false);
        toastSuccess(`Vessel ${isApproved ? "approved" : "unapproved"} successfully`);
        if (filters.vessel) {
          getSearchedData(filters);
        } else {
          getAllVessels(filters);
        }
      })
      .catch((err) => {
        setLoader(false);
        toastError(err?.data?.message || "Failed to update approval status");
      });
  };

  const onChangeOrganization = (id) => {
    setFleetFilters({ ...fleetFilters, offset: 1 });
    const selectedOrganization =
      id === "allFleets"
        ? "allFleets"
        : allOrganization?.find((org) => org._id === id);

    setSelectedOrganization(selectedOrganization);
  };

  const onChangePagination = (type, api) => {
    if (api === "vessel") {
      let newFilters = {};
      if (type === "inc") {
        newFilters = { ...filters, offset: filters.offset + 1 };
      } else if (type === "first") {
        newFilters = { ...filters, offset: 1 };
      } else {
        if (filters.offset <= 1) return;
        newFilters = { ...filters, offset: filters.offset - 1 };
      }
      setLoader(true);
      dispatch(actions.allVessels(newFilters))
        .then((res) => {
          setLoader(false);
          setFilters({ ...newFilters, totalPages: res?.data?.totalPages || 0, totalItems: res?.data?.totalItems || 0 });
        })
        .catch((err) => {
          toastError();
          setLoader(false);
        });
    } else {
      let newFilters = {};
      if (type === "inc") {
        newFilters = { ...fleetFilters, offset: fleetFilters.offset + 1 };
      } else if (type === "first") {
        newFilters = { ...fleetFilters, offset: 1 };
      } else {
        if (fleetFilters.offset <= 1) return;
        newFilters = { ...fleetFilters, offset: fleetFilters.offset - 1 };
      }
      setLoader(true);
      dispatch(
        actions.getFleetByOrg({
          ...newFilters,
          organizationId: selectedOrganization?._id,
        })
      )
        .then((res) => {
          setLoader(false);
          setFleetFilters({ ...newFilters, totalPages: res?.data?.totalPages || 0, totalItems: res?.data?.totalItems || 0 });
        })
        .catch((err) => {
          toastError();
          setLoader(false);
        });
    }
  };

  const onDiscardFleet = () => {
    if (selectedFleetId) {
      setLoader(true);
      actions
        .markFleet({
          id: selectedFleetId,
          status: false,
        })
        .then((res) => {
          onCloseModal();
          setLoader(false);
          if (filters.vessel) {
            getSearchedData(filters);
          } else {
            getInititalData(filters);
          }
          setSelectedFleetId("");
        })
        .catch((err) => {
          setLoader(false);
          toastError();
        });
    }

    updateFleetData({ _id: selectedFleetId, superAdminApproval: "rejected" })
      .then((res) => {
        onCloseModal();
        setLoader(false);
        if (filters.vessel) {
          getSearchedData(filters);
        } else {
          getInititalData(filters);
        }
        setSelectedFleetId("");
      })
      .catch((err) => {
        setLoader(false);
        toastError();
      });
  };

  const fleetShowing = (
    <p>
      Showing{" "}
      <span>{(fleetFilters.offset + 1 - 1) * fleetFilters.limit || 1}</span>-
      <span>{(fleetFilters.offset + 1 || 1) * fleetFilters.limit}</span> of{" "}
      <span>{(fleetFilters.offset + 1 || 1) * fleetFilters.limit}</span>
    </p>
  );

  const addNewSplitHire = () => {
    let splitHire =
      (vessel && vessel.splitHire && JSON.parse(vessel.splitHire)) || [];
    if (!!splitHire.find((item) => item.NoDays === 0)) return;
    splitHire.push({ NoDays: 0, applied: 0, disable: false, hireRate: 0 });
    setVessel({
      ...vessel,
      splitHire: JSON.stringify(splitHire),
    });
  };
  const onChangeBunkerPriceOverridden = (e) => {
    let { name = "", checked = "" } = e.target || {};
    let newUpdatedFleet = { ...vessel };
    newUpdatedFleet[name] = checked;
    setVessel(newUpdatedFleet);
  };

  const delayPortSearch = useCallback(
    debounce((search) => onSearchPortList(search), 500),
    []
  );
  const onSearchPortList = (value) => {
    if (value) {
      setPortLoading(true);
      portsByChar(value)
        .then((res) => {
          setPortLoading(false);
          setSavePortList(
            Array.isArray(res.data.list)
              ? res.data.list.map((item) => ({
                ...item,
                portLabel: `${item.name}${item.country ? ` (${item.country})` : ''}`
              }))
              : []
          );
        })
        .catch((err) => {
          setPortLoading(false);
        });
    }
  };

  const onChangeSplitHire = (index, e, isDelete = false) => {
    let splitHire =
      (vessel && vessel.splitHire && JSON.parse(vessel.splitHire)) || [];
    if (isDelete) splitHire.splice(index, 1);
    else {
      const { name = "", value = "" } = e.target;
      splitHire[index][name] = Number(value);
    }
    const udpatedvessel = {
      ...vessel,
      splitHire: JSON.stringify(splitHire),
    };
    setVessel(udpatedvessel);
  };

  return (
    <Grid container alignContent="flex-start" className="min-h-[calc(100vh-106px)]">
      <Grid item xs={12}>
        <div className="flex flex-wrap items-center justify-between gap-2 mb-2">
          <button
            type="button"
            onClick={() => history.goBack()}
            className="h-7 px-3 text-[11px] font-medium text-slate-900 bg-white hover:bg-slate-100 border border-slate-300 rounded-none flex items-center justify-center gap-1.5 transition-colors cursor-pointer whitespace-nowrap"
          >
            <LuArrowLeft size={14} /> Go back
          </button>
          <button
            type="button"
            onClick={() => setOpen(true)}
            className="h-7 px-3 bg-[#313C4C] hover:bg-[#1e2632] text-white text-[11px] font-medium rounded-none flex items-center justify-center gap-1.5 shadow-sm transition-colors cursor-pointer whitespace-nowrap"
          >
            <LuPlus size={14} /> Create Vessel
          </button>
        </div>
      </Grid>

      <Grid item xs={12}>
        <div className="flex flex-wrap items-end justify-between gap-2 mb-2">
          <CustomTabs
            active={value}
            onChange={handleChange}
            tabs={[{ label: "Vessel List", key: 1 }, { label: "Fleet List", key: 2 }]}
          />
          {value === 1 ? (
            <div className="w-full sm:w-72">
              <label htmlFor="vessel-information-search" className="block text-[11px] font-medium text-slate-700 mb-0.5">Search vessels</label>
              <input
                id="vessel-information-search"
                type="search"
                value={search}
                onChange={(e) => searchVessel(e.target.value)}
                placeholder="Search by vessel name"
                className="w-full h-7 px-2 py-1 border border-slate-300 bg-white text-slate-800 rounded-none text-[11px] font-medium focus:outline-none focus:border-[#313C4C]"
              />
            </div>
          ) : (
            <div className="w-full sm:w-72">
              <label id="vessel-organization-label" className="block text-[11px] font-medium text-slate-700 mb-0.5">Organization</label>
              <FormControl variant="outlined" size="small" fullWidth>
                <Select
                  labelId="vessel-organization-label"
                  value={selectedOrganization === "allFleets" ? "allFleets" : selectedOrganization?._id || ""}
                  onChange={(e) => onChangeOrganization(e.target.value)}
                  disabled={!isSuperAdminLogin()}
                  displayEmpty
                  className="h-7 !rounded-none !bg-white !text-[11px] [&_.MuiSelect-select]:!py-1 [&_.MuiSelect-select]:!px-2"
                  MenuProps={{ classes: { paper: "admin-form-menu" } }}
                >
                  <MenuItem dense value="" disabled>Select organization</MenuItem>
                  <MenuItem dense value="allFleets">All Fleets</MenuItem>
                  {Array.isArray(allOrganization) && allOrganization.map((item) => (
                    <MenuItem key={item._id} dense value={item._id}>{item.organizationName}</MenuItem>
                  ))}
                </Select>
              </FormControl>
            </div>
          )}
        </div>
      </Grid>

      <Grid item xs={12}>
        {value === 1 ? (
          <Box>
            <TableContainer component={Paper} className="!rounded-none !shadow-sm overflow-x-auto scroll-thin">
              <Table className="universal-table">
                <TableHead>
                  <TableRow>
                    <TableCell>Vessel Name</TableCell>
                    <TableCell>DWT</TableCell>
                    <TableCell>Draft</TableCell>
                    <TableCell>Owner</TableCell>
                    <TableCell>Ship Country</TableCell>
                    <TableCell className="!w-28 !min-w-[112px]">Actions</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {loader ? (
                    <TableRow>
                      <TableCell colSpan={6} align="center" className="!bg-white">
                        <Box display="flex" justifyContent="center" alignItems="center" height="440px">
                          <CircularProgress size={24} aria-label="Loading vessels" />
                        </Box>
                      </TableCell>
                    </TableRow>
                  ) : Array.isArray(allVessels) && allVessels.length ? (
                    allVessels.map((item, index) => {
                      const {
                        vesselName = "",
                        vesselDwt = "",
                        vesselDraftS = "",
                        vesselShipowner = "",
                        vesselCountry = "",
                      } = item;
                      return (
                        <TableRow
                          key={index}
                          className="h-7 cursor-pointer hover:bg-slate-100"
                          onDoubleClick={() => {
                            onClickEdit(item, item._id);
                          }}
                        >
                          <TableCell>{vesselName}</TableCell>
                          <TableCell>{vesselDwt}</TableCell>
                          <TableCell>{vesselDraftS}</TableCell>
                          <TableCell>{vesselShipowner}</TableCell>
                          <TableCell>{vesselCountry}</TableCell>
                          <TableCell className="!w-28 !min-w-[112px]">
                            <div className="flex items-center justify-center gap-2">
                              {isSuperAdminLogin() && (
                                <Switch
                                  checked={item?.isApproved || false}
                                  onChange={(event) => handleApproveVessel(item, event.target.checked)}
                                  size="small"
                                  color="primary"
                                  inputProps={{ "aria-label": `Approve ${vesselName}` }}
                                />
                              )}
                              <button
                                type="button"
                                title="Edit vessel"
                                aria-label={`Edit ${vesselName}`}
                                onClick={() => onClickEdit(item, item._id)}
                                className="h-7 w-7 inline-flex items-center justify-center text-[#313C4C] hover:bg-slate-200 transition-colors"
                              >
                                <EditIcon className="!text-[14px]" />
                              </button>
                            </div>
                          </TableCell>
                        </TableRow>
                      );
                    })
                  ) : hasFetchedVessels ? (
                    <TableRow>
                      <TableCell
                        colSpan="6"
                        align="center"
                        className="!bg-white"
                      >
                        No Vessel Found.
                      </TableCell>
                    </TableRow>
                  ) : null}
                </TableBody>
              </Table>
              {/* <Pagination count={totalPages} showFirstButton showLastButton onChange={onPageChange} page={filters.page || 0} /> */}
              {/* <Pagination count={10} showFirstButton showLastButton page={0} /> */}
              <CustomPagination
                onChangePagination={onChangePagination}
                filters={filters}
                totalPage={filters?.totalItems}
              />
            </TableContainer>
          </Box>
        ) : (
          <Box>
            <TableContainer component={Paper} className="!rounded-none !shadow-sm overflow-x-auto scroll-thin">
              <Table className="universal-table">
                <TableHead>
                  <TableRow>
                    <TableCell>Vessel Name</TableCell>
                    <TableCell>DWT</TableCell>
                    <TableCell>Port Opening</TableCell>
                    <TableCell>Date Opening</TableCell>
                    <TableCell>Hire Per Day</TableCell>
                    <TableCell>Hire GBB</TableCell>
                    <TableCell>Created By</TableCell>
                    <TableCell>Edit Vessel</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {loader ? (
                    <TableRow>
                      <TableCell colSpan={8} align="center" className="!bg-white">
                        <Box display="flex" justifyContent="center" alignItems="center" height="440px">
                          <CircularProgress size={24} aria-label="Loading fleets" />
                        </Box>
                      </TableCell>
                    </TableRow>
                  ) : Array.isArray(allFleetByOrg) && allFleetByOrg.length ? (
                    allFleetByOrg.map((item, index) => {
                      const {
                        vesselName = "",
                        dwt = "",
                        port = "",
                        dateOpen = "",
                        hirePerDay = "",
                        hireGbb = "",
                        createdUserName = "",
                      } = item;
                      return (
                        <TableRow
                          key={index}
                          className="h-7 cursor-pointer hover:bg-slate-100"
                          onDoubleClick={() => {
                            setSelectedFleetId(item._id);
                            onClickEdit(JSON.parse(item.vessel));
                          }}
                        >
                          <TableCell>{vesselName}</TableCell>
                          <TableCell>{dwt}</TableCell>
                          <TableCell>{port || ""}</TableCell>
                          <TableCell>
                            {dateOpen
                              ? moment(dateOpen).format("DD/MMM/yyyy")
                              : ""}
                          </TableCell>
                          <TableCell>{hirePerDay}</TableCell>
                          <TableCell>{hireGbb}</TableCell>
                          <TableCell>{createdUserName}</TableCell>
                          <TableCell>
                            <button
                              type="button"
                              title="Edit fleet vessel"
                              aria-label={`Edit ${vesselName}`}
                              className="h-7 w-7 inline-flex items-center justify-center text-[#313C4C] hover:bg-slate-200 transition-colors"
                              onClick={() => {
                                setSelectedFleetId(item._id);
                                onClickEdit(JSON.parse(item.vessel));
                              }}
                            >
                              <EditIcon className="!text-[14px]" />
                            </button>
                          </TableCell>
                        </TableRow>
                      );
                    })
                  ) : hasFetchedFleets ? (
                    <TableRow>
                      <TableCell
                        colSpan="8"
                        align="center"
                        className="!bg-white"
                      >
                        No Fleet Found.
                      </TableCell>
                    </TableRow>
                  ) : null}
                </TableBody>
              </Table>
              {/* <Pagination count={totalPages} showFirstButton showLastButton onChange={onPageChange} page={filters.page || 0} /> */}
              {/* <Pagination count={10} showFirstButton showLastButton page={0} /> */}
              <CustomPagination
                onChangePagination={onChangePagination}
                filters={fleetFilters}
                totalPage={fleetFilters?.totalItems}
                apiName="fleet"
              />
            </TableContainer>
          </Box>
        )}
      </Grid>

      <CustomAddModal
        open={open}
        saveLabel={value === 1 ? 'update' : 'create'}
        title={value === 1 ? 'Update Vessel' : 'Create Vessel'}
        maxWidth="lg"
        addThirdBtn={value === 2}
        thirdBtnAction={onDiscardFleet}
        thirdBtnLabel="Discard"
        handleClose={onCloseModal}
        onSubmitConfirm={onSubmitConfirm}
      >
        <AddNewVessel vessel={vessel}
          onChangeHandler={onChangeHandler}
          addNewSplitHire={addNewSplitHire}
          onChangeBunkerPriceOverridden={onChangeBunkerPriceOverridden}
          onChangeSplitHire={onChangeSplitHire}
          delayPortSearch={delayPortSearch}
          portLoading={portLoading}
          onChangePort={onChangePort}
          savePortList={savePortList}
        />
      </CustomAddModal>
    </Grid>
  );
}
